import React from 'react';
import WalletsList from './WalletsList';
import styles from '../CardsAndWallets.module.scss';
import Box from '@mui/material/Box';
import RequestsForWalletUsage from './RequestsForWalletUsage';

const CryptoWallets = () => (
  <Box className={styles.tabContent}>
    <RequestsForWalletUsage />
    <WalletsList />
  </Box>
);

export default CryptoWallets;
